// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"0dfd9a8e","99":"57f47af0","256":"748a3d14","498":"753600d1","551":"8e28ffee","572":"c397e5a6","616":"6abb1d24","617":"a069670d","697":"fb90c785","828":"b9bec337","851":"828c4e33"}[chunkId] + ".chunk.js";
};